if (!customElements.get("nss-blog")) {
    customElements.define("nss-blog", class NSSBlog extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                loadMore: ".js-nss-blog-load-more",
                container: ".js-nss-blog-container",
                item: ".js-blog-post-item",
                nav: ".nss-blog__navigation",
                badge: ".js-blog-post-item-badge",
                activeTag: ".js-navigation-tags a.is-active"
            };
            this.onLoadClick = this.handleButtonClick.bind(this);
        }

        connectedCallback() {
            this.addEventListener('click', this.onLoadClick);
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.onLoadClick);
        }

        handleButtonClick(e) {
            const loadMoreBtn = e.target.closest(this.selectors.loadMore);
            if (!loadMoreBtn) return;

            e.preventDefault();

            if (loadMoreBtn.hasAttribute("data-next")) {
                this.handleLocalShowMore(loadMoreBtn);
            } else {
                this.handleLoadMore(loadMoreBtn);
            }
        }

        /**
         * SHOW MORE (Local)
         * Unhides items that were hidden by Liquid (default) or by pagination (.hidden-filter).
         */
        handleLocalShowMore(button) {
            const perPage = parseInt(this.getAttribute('data-per-page')) || 6;

            // 1. Identify what the user is currently filtering by
            const activeTagEl = document.querySelector(this.selectors.activeTag);
            const activeTag = activeTagEl ? activeTagEl.getAttribute('data-tag') : 'all';

            // 2. Find ALL hidden items (both .hidden from liquid and .hidden-filter from JS)
            const allHiddenItems = this.querySelectorAll(`${this.selectors.item}.hidden, ${this.selectors.item}.hidden-filter`);

            // 3. Filter the hidden items to find ones that actually match the active tag
            const validHiddenItems = Array.from(allHiddenItems).filter(item => {
                if (activeTag === 'all') return true;

                const badge = item.querySelector(this.selectors.badge);
                const itemTag = badge ? badge.getAttribute('data-tag') : null;
                return itemTag === activeTag;
            });

            if (validHiddenItems.length === 0) {
                this.hideNavigation(button);
                return;
            }

            // 4. Show the next chunk
            const toShow = validHiddenItems.slice(0, perPage);
            toShow.forEach(item => {
                item.classList.remove('hidden', 'hidden-filter');
            });

            // 5. Check if there's anything left to show for this specific tag
            const remainingValid = validHiddenItems.length - toShow.length;
            if (remainingValid <= 0) {
                this.hideNavigation(button);
            }
        }

        hideNavigation(button) {
            const navContainer = button.closest(this.selectors.nav);
            if (navContainer) navContainer.classList.add('hidden');
            else button.classList.add('hidden');
        }

        handleLoadMore(button) {
            const blogUrl = button.getAttribute("href");
            if (!blogUrl || button.classList.contains('loading')) return;

            const activeTagEl = document.querySelector(this.selectors.activeTag);
            const activeTag = activeTagEl ? activeTagEl.getAttribute('data-tag') : 'all';

            button.classList.add('loading');
            const sectionId = button.getAttribute("data-section") || "nss-main-blog";
            const separator = blogUrl.includes('?') ? '&' : '?';
            const fetchUrl = `${blogUrl}${separator}sections=${sectionId}`;

            fetch(fetchUrl)
                .then(res => res.json())
                .then(response => {
                    const htmlString = response[sectionId];
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(htmlString, 'text/html');
                    const newItems = doc.querySelectorAll(this.selectors.item);
                    const container = this.querySelector(this.selectors.container);

                    if (container && newItems.length > 0) {
                        newItems.forEach(item => {
                            item.classList.remove('hidden-filter');

                            if (activeTag !== 'all') {
                                const badge = item.querySelector(this.selectors.badge);
                                const itemTag = badge ? badge.getAttribute('data-tag') : null;
                                if (itemTag !== activeTag) {
                                    item.classList.add('hidden');
                                } else {
                                    item.classList.remove('hidden');
                                }
                            } else {
                                item.classList.remove('hidden');
                            }
                            container.appendChild(item);
                        });
                    }

                    const newButton = doc.querySelector(this.selectors.loadMore);
                    if (newButton) {
                        button.parentElement.replaceChild(newButton, button);
                    } else {
                        this.hideNavigation(button);
                        button.remove();
                    }
                })
                .catch(err => console.error("NSS Load More Error:", err))
                .finally(() => button.classList.remove('loading'));
        }
    });
}